import DetailTransferInfo from './DetailTransferInfo.vue';

export default DetailTransferInfo;